import styles from "./Editor.module.scss";
import clsx from "clsx";
import React, {useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
import Button from "./Button";

const Editor = ({show, title, onSubmit, onCancel, onDelete, onShow, submitLabel, cancelLabel, children}) => {
  const [showClass, setShowClass] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        setShowClass(true);

        !!onShow && onShow();
      }, 10);
    } else {
      setTimeout(() => {
        setShowClass(false);
        setSaving(false);
      }, 200);
    }
  }, [show, onShow]);

  if (!show && !showClass) {
    return null;
  }

  return <div className={clsx(styles.editor, showClass && show ? styles.show : null)}>
    <div className={styles.editorBackdrop}/>

    <Form noValidate onSubmit={e => {
      setSaving(true);

      e.preventDefault();

      onSubmit(e).finally(() => setSaving(false));
    }}>
      <div className={styles.editorContent}>
        <div className={styles.editorTitleActions}>
          <div className={styles.editorTitle}>{title}</div>
          <div className={styles.editorActions}>
            {onDelete &&
              <Button onClick={onDelete} variant="danger" className={styles.cancelButton} disabled={saving}>
                <span className="material-icons">delete_forever</span>
              </Button>}

            <Button onClick={onCancel} variant="secondary" disabled={saving}>{cancelLabel}</Button>

            <Button type="submit" variant="primary" disabled={saving}>{submitLabel}</Button>
          </div>
        </div>

        <div className={styles.editorChildren}>
          {children}
        </div>
      </div>
    </Form>
  </div>;
};

export default Editor;
